export default "__VITE_ASSET__DkcSDgmp__"